module.exports = __webpack_public_path__ + "img/xcx.3944c267.jpg";